import{makeStyles as e,createStyles as r}from"@material-ui/core";var t=e((function(e){return r({contentTextBase:{color:e.palette.grey[900]}})}));export{t as useModalContentTextClasses};
